angular.module( 'acme.view.application.reports.create.modals.selectTime', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.reports.create.modals.selectTime.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var reportsCreateModalsSelectTime = {
        name: 'application.reports.create.modals.selectTime',
        url: '/reports/create/modals/selectTime',
        views: {
          "main": {
            controller: 'ReportsCreateModalsSelectTimeController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/reports/create/modals/selectTime/selectTime.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(reportsCreateModalsSelectTime);
});
